var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import classNames from 'classnames';
import { hasVerticalScrollbar, getScrollBarSize } from '@autobest-ui/utils';
import Portal from '../portal';
import Mask from '../mask';
import Child from './Child';
var Drawer = /** @class */function (_super) {
  __extends(Drawer, _super);
  function Drawer(props) {
    var _this = _super.call(this, props) || this;
    _this.prefixCls = 'ab-drawer';
    _this.childRef = /*#__PURE__*/React.createRef();
    _this.onClose = function () {
      var _a = _this.props,
        maskClosable = _a.maskClosable,
        onClose = _a.onClose,
        name = _a.name;
      if (maskClosable && onClose) {
        onClose(false, name);
      }
    };
    _this.onCancel = function () {
      var _a = _this.props,
        onClose = _a.onClose,
        name = _a.name;
      if (onClose) {
        onClose(false, name);
      }
    };
    // 用于标志是否弹出，防止在单页面应用时，没有onEnter，但是在销毁时执行onExited
    _this.isEnter = false;
    _this.onEnter = function () {
      _this.isEnter = true;
      var currentDocument = window.document.body;
      var hiddenScroll = _this.props.hiddenScroll;
      if (hiddenScroll) {
        currentDocument.style.overflow = 'hidden';
        var scrollSize = getScrollBarSize();
        if (hasVerticalScrollbar(scrollSize)) {
          currentDocument.style.paddingRight = "".concat(scrollSize, "px");
        }
      }
    };
    _this.onExited = function () {
      if (!_this.isEnter) {
        return;
      }
      var currentDocument = window.document.body;
      var hiddenScroll = _this.props.hiddenScroll;
      if (hiddenScroll && currentDocument) {
        currentDocument.style.overflow = '';
        currentDocument.style.paddingRight = '';
      }
      // 插入元素，在exited时， 设置为hidden
      _this.setState({
        isHidden: true
      });
      var _a = _this.props,
        onDestroy = _a.onDestroy,
        name = _a.name;
      if (onDestroy) {
        onDestroy(name);
      }
    };
    _this.state = {
      isHidden: !props.visible
    };
    return _this;
  }
  Drawer.getDerivedStateFromProps = function (nextProps, prevState) {
    // 在visible发生改变时，判断是否hidden, 并设置hidden:false,
    // 注：不能在onEnter处理，否则动画无法执行
    if (nextProps.visible && prevState.isHidden) {
      return {
        isHidden: false
      };
    }
    return null;
  };
  Drawer.prototype.componentWillUnmount = function () {
    // 销毁时，如果没有执行onExited，则在此执行
    this.onExited();
  };
  Drawer.prototype.renderMask = function () {
    var _a;
    var _b = this.props,
      visible = _b.visible,
      showMask = _b.showMask;
    if (showMask) {
      return /*#__PURE__*/React.createElement(Mask, {
        onClose: this.onClose,
        className: classNames((_a = {}, _a["".concat(this.prefixCls, "-hidden")] = this.state.isHidden, _a)),
        visible: visible,
        timeout: 300
      });
    }
    return null;
  };
  Drawer.prototype.renderChild = function () {
    var _a;
    var _b = this.props,
      visible = _b.visible,
      children = _b.children,
      className = _b.className,
      extraProps = __rest(_b, ["visible", "children", "className"]);
    return /*#__PURE__*/React.createElement(Child, __assign({}, extraProps, {
      visible: visible,
      className: classNames(className, (_a = {}, _a["".concat(this.prefixCls, "-hidden")] = this.state.isHidden, _a)),
      prefixCls: this.prefixCls,
      onCancel: this.onCancel,
      onEnter: this.onEnter,
      onExited: this.onExited,
      ref: this.childRef
    }), children);
  };
  Drawer.prototype.render = function () {
    var _a = this.props,
      visible = _a.visible,
      isInsertNode = _a.isInsertNode;
    if (isInsertNode) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.renderMask(), this.renderChild());
    }
    if (visible || this.childRef.current) {
      return /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(React.Fragment, null, this.renderMask(), this.renderChild()));
    }
    return null;
  };
  // 默认值
  Drawer.defaultProps = {
    placement: 'left',
    width: '2.45rem',
    height: '2.45rem',
    isInsertNode: false,
    closable: true,
    showMask: true,
    maskClosable: true,
    hiddenScroll: true,
    keyboard: true
  };
  return Drawer;
}(React.Component);
export default Drawer;